import AsyncStorage from "@react-native-community/async-storage";
//import { AsyncStorage } from "react-native";

export default AsyncStorage;
